const SETTINGS_LAYOUT_0 = [
  {
    name: 'SINUSOIDAL_STARTUP',
    type: 'bool',
    label: 'escSinusoidalStartup',
    visibleIf: (settings) => false,
  },
  {
    name: 'COMPLEMENTARY_PWM',
    type: 'bool',
    label: 'escComplementaryPwm',
  },
  {
    name: 'VARIABLE_PWM_FREQUENCY',
    type: 'bool',
    label: 'escVariablePwmFrequency',
  },
  {
    name: 'STUCK_ROTOR_PROTECTION',
    type: 'bool',
    label: 'escStuckRotorProtection',
  },
  {
    name: 'STALL_PROTECTION',
    type: 'bool',
    label: 'escStallProtection',
    visibleIf: (settings) => false,
  },
  {
    name: 'TIMING_ADVANCE',
    type: 'number',
    min: 0,
    max: 22.5,
    step: 7.5,
    label: 'escTimingAdvance',
    displayFactor: 7.5,
  },
  {
    name: 'MOTOR_KV',
    type: 'number',
    min: 20,
    max: 10220,
    step: 40,
    label: 'escMotorKv',
    displayFactor: 40,
    displayOffset: 20,
  },
  {
    name: 'MOTOR_POLES',
    type: 'number',
    min: 2,
    max: 36,
    step: 1,
    label: 'escMotorPoles',
  },
  {
    name: 'STARTUP_POWER',
    type: 'number',
    min: 50,
    max: 250,
    step: 1,
    label: 'escStartupPower',
  },
  {
    name: 'PWM_FREQUENCY',
    type: 'number',
    min: 12,
    max: 48,
    step: 1,
    label: 'escPwmFrequency',
    visibleIf: (settings) => true,
  },
  {
    name: 'BRAKE_ON_STOP',
    type: 'bool',
    label: 'escBrakeOnStop',
  },
];

const SETTINGS_LAYOUT_1 = [
  ...SETTINGS_LAYOUT_0,
  {
    name: 'BEEP_VOLUME',
    type: 'number',
    label: 'escBeepVolume',
    min: 0,
    max: 11,
    step: 1,
  },
  {
    name: 'INTERVAL_TELEMETRY',
    type: 'bool',
    label: 'escIntervalTelemetry',
    visibleIf: (settings) => false,
  },
  {
    name: 'SERVO_LOW_THRESHOLD',
    type: 'number',
    label: 'escServoLowThreshold',
    min: 750,
    max: 1250,
    step: 1,
    displayFactor: 2,
    displayOffset: 750,
    visibleIf: (settings) => false,
  },
  {
    name: 'SERVO_HIGH_THRESHOLD',
    type: 'number',
    label: 'escServoHighThreshold',
    min: 1750,
    max: 2250,
    step: 1,
    displayFactor: 2,
    displayOffset: 1750,
    visibleIf: (settings) => false,
  },
  {
    name: 'SERVO_NEUTRAL',
    type: 'number',
    label: 'escServoNeutral',
    min: 1374,
    max: 1630,
    step: 1,
    displayFactor: 1,
    displayOffset: 1374,
    visibleIf: (settings) => false,
  },
  {
    name: 'SERVO_DEAD_BAND',
    type: 'number',
    label: 'escServoDeadBand',
    min: 0,
    max: 100,
    step: 1,
    visibleIf: (settings) => false,
  },
  {
    name: 'LOW_VOLTAGE_CUTOFF',
    type: 'bool',
    label: 'escLowVoltageCutoff',
  },
  {
    name: 'LOW_VOLTAGE_THRESHOLD',
    type: 'number',
    label: 'escLowVoltageThreshold',
    min: 250,
    max: 350,
    step: 1,
    displayFactor: 1,
    displayOffset: 250,
  },
  {
    name: 'RC_CAR_REVERSING',
    type: 'bool',
    label: 'escRcCarReversing',
    visibleIf: (settings) => false,
  },
];

const SETTINGS_LAYOUT_2 = [
  ...SETTINGS_LAYOUT_1,
  {
    name: 'USE_HALL_SENSORS',
    type: 'bool',
    label: 'escHallSensors',
    visibleIf: (settings) => false,
  },
  {
    name: 'SINE_MODE_RANGE',
    type: 'number',
    label: 'escSineModeRange',
    min: 5,
    max: 25,
    step: 1,
    visibleIf: (settings) => false,
  },
  {
    name: 'BRAKE_STRENGTH',
    type: 'number',
    label: 'escBrakeStrength',
    min: 1,
    max: 10,
    step: 1,
    visibleIf: (settings) => false,
  },
  {
    name: 'ESC_PROTOCOL',
    type: 'enum',
    label: 'escSelectProtocol',
    options: [
      {
        value: 0,
        label: 'Auto',
      },
      {
        value: 1,
        label: 'DShot',
      },
      {
        value: 2,
        label: 'Servo',
      },
      {
        value: 3,
        label: 'Serial',
      },
      {
        value: 4,
        label: 'EDT ARM',
      },
    ],
    visibleIf: (settings) => false,
  },
  {
    name: 'RAMP_SPEED',
    type: 'number',
    label: 'escRampSpeed',
    min: 2,
    max: 15,
    step: 1,
    visibleIf: (settings) => true,
  },  
  {
    name: 'DUTY_RAMP_DOWN',
    type: 'number',
    label: 'escDutyRampDown',
    min: 1,
    max: 15,
    step: 1,
    visibleIf: (settings) => settings.SUB_REVISION >= 11 && settings.MAIN_REVISION >= 3,
  },  
  {
    name: 'BAT_CELL_COUNT',
    type: 'enum',
    label: 'escBatCellCount',
    options: [
      {
        value: 0,
        label: 'Auto',
      },
      {
        value: 1,
        label: '1S',
      },
      {
        value: 2,
        label: '2S',
      },
      {
        value: 3,
        label: '3S',
      },
      {
        value: 4,
        label: '4S',
      },
      {
        value: 5,
        label: '5S',
      },
      {
        value: 6,
        label: '6S',
      },
      {
        value: 7,
        label: '7S',
      },
      {
        value: 8,
        label: '8S',
      },
      {
        value: 9,
        label: '9S',
      },
      {
        value: 10,
        label: '10S',
      },
      {
        value: 255,
        label: 'NOT-SET',
      },
    ],
    visibleIf: (settings) => settings.SUB_REVISION >= 20 && settings.MAIN_REVISION >= 3,
  },
];

let SETTINGS_LAYOUT_3 = [
  ...SETTINGS_LAYOUT_2,
];

SETTINGS_LAYOUT_3[5] = {
  name: 'TIMING_ADVANCE',
  type: 'number',
  min: 1,
  max: 23,
  step: 1,
  label: 'escTimingAdvance',
  displayFactor: 1,
};

const COMMON = {
  '0': { base: SETTINGS_LAYOUT_0 },
  '1': { base: SETTINGS_LAYOUT_1 },
  '2': { base: SETTINGS_LAYOUT_2 },
  '3': { base: SETTINGS_LAYOUT_3 },
};

const INDIVIDUAL_SETTINGS_0 = [
  {
    name: 'MOTOR_DIRECTION',
    type: 'bool',
    label: 'escDirectionReversed',
  },
  {
    name: 'BIDIRECTIONAL_MODE',
    type: 'bool',
    label: 'escBidirectionalMode',
  },
];

const INDIVIDUAL_SETTINGS_1 = [
  ...INDIVIDUAL_SETTINGS_0,
  {
    name: 'STARTUP_MELODY',
    type: 'melody',
    label: 'startupMelody',
    value: [2,58,4,32,52,66,13,0,69,45,13,0,185,30,13,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    melodyLength: 128,
  },
];

const INDIVIDUAL_SETTINGS_2 = [
  ...INDIVIDUAL_SETTINGS_1,
  {
    name: 'STARTUP_MELODY',
    type: 'melody',
    label: 'startupMelody',
    value: [2,58,4,32,52,66,13,0,69,45,13,0,185,30,13,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    melodyLength: 128,
  },
  {
    name: 'DEVICE_ID',
    type: 'sn',
    label: 'device_id',
  },
  {
    name: 'DEVICE_KEY',
    type: 'sn',
    label: 'device_key',
  },
];


const INDIVIDUAL_SETTINGS_3 = [
  ...INDIVIDUAL_SETTINGS_2,
];

const INDIVIDUAL = {
  '0': { base: INDIVIDUAL_SETTINGS_0 },
  '1': { base: INDIVIDUAL_SETTINGS_1 },
  '2': { base: INDIVIDUAL_SETTINGS_2 },
  '3': { base: INDIVIDUAL_SETTINGS_3 },
};

const DEFAULT_SETTINGS_0 = {
  MOTOR_DIRECTION: 0,
  BIDIRECTIONAL_MODE: 0,
  SINUSOIDAL_STARTUP: 0,
  COMPLEMENTARY_PWM: 1,
  VARIABLE_PWM_FREQUENCY: 1,
  STUCK_ROTOR_PROTECTION: 1,
  TIMING_ADVANCE: 2,
  PWM_FREQUENCY: 30,
  STARTUP_POWER: 100,
  MOTOR_KV: 55,
  MOTOR_POLES: 14,
  BRAKE_ON_STOP: 0,
  STALL_PROTECTION: 0,
};

const DEFAULT_SETTINGS_1 = {
  ...DEFAULT_SETTINGS_0,
  BEEP_VOLUME: 5,
  INTERVAL_TELEMETRY: 0,
  SERVO_LOW_THRESHOLD: 128,
  SERVO_HIGH_THRESHOLD: 128,
  SERVO_NEUTRAL: 128,
  SERVO_DEAD_BAND: 50,
  LOW_VOLTAGE_CUTOFF: 0,
  LOW_VOLTAGE_THRESHOLD: 50,
  RC_CAR_REVERSING: 0,
  STARTUP_MELODY: [2,58,4,32,52,66,13,0,69,45,13,0,185,30,13,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
};

const DEFAULT_SETTINGS_2 = {
  ...DEFAULT_SETTINGS_1,
  USE_HALL_SENSORS: 0,
  SINE_MODE_RANGE: 8,
  BRAKE_STRENGTH: 10,
  ESC_PROTOCOL: 0,
  RAMP_SPEED: 8,
  DUTY_RAMP_DOWN: 10,
  BAT_CELL_COUNT: 4,
};

const DEFAULT_SETTINGS_3 = {
  ...DEFAULT_SETTINGS_2,
  TIMING_ADVANCE: 15,
};

const DEFAULTS = {
  '0': DEFAULT_SETTINGS_0,
  '1': DEFAULT_SETTINGS_1,
  '2': DEFAULT_SETTINGS_2,
  '3': DEFAULT_SETTINGS_3,
};

const settings = {
  DEFAULTS,
  INDIVIDUAL,
  COMMON,
};

export default settings;
